module.exports = __webpack_public_path__ + "img/ambientacion2.9edb20d6.jpg";